import {Observable} from "rxjs";
import {Request} from "../request.abstract";
import {User} from "./api.models";
import {Observer} from "rxjs/Observer";

export class UsersEndpoint extends Request {
    protected cache: User[];
    protected cacheToken: string;

    collection(): Observable<User[]> {
        return Observable.create((observer: Observer<any>) => {
            if (this.cache && this.cacheToken === this.settings.token) {
                observer.next(this.cache);
                observer.complete();

                return;
            }

            this.get('/v1/users').subscribe(
                (users: User[]) => {
                    this.cache      = [];
                    this.cacheToken = this.settings.token;

                    users.forEach((user: User) => {
                        this.cache.push(Object.assign(user));
                    });

                    observer.next(users);
                },
                (error: any) => {
                    observer.error(error);
                },
                () => {
                    observer.complete();
                }
            )
        });
    }

    resource(id: number): Observable<User> {
        return this.get('/v1/users/' + id);
    }

    store(user: User): Observable<User> {
        this.resetCache();
        
        return this.post('/v1/users', user);
    }

    update(user: User): Observable<User> {
        this.resetCache();

        return this.patch('/v1/users/' + user.id, user);
    }

    remove(id: number): Observable<boolean> {
        this.resetCache();

        return this.delete('/v1/users/' + id);
    }

    private resetCache(): void {
        this.cache      = null;
        this.cacheToken = null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/users/api.service.ts